import JwtDecode from 'jwt-decode';
import idleTimer from '../../utils/idleTimer';
import { notificationHelper, isElectron } from '../../utils/helper';
import TokenManager from '../../utils/TokenManager';
import { getLoginPageUrl } from '../../utils/commonHelper';
const initSessionHandler = oktaAuth => {
  idleTimer.init();
  idleTimer.on('active', onSessionActiveAfterIdle);
  onSessionActive(oktaAuth);
};
const onSessionActive = oktaAuthObj => {
  const isExpiryTime = TokenManager.getItem(TokenManager.tokenExpiryDate);
  if (isExpiryTime) {
    const expiryTime = new Date(isExpiryTime).getTime() - 300000;
    const currentTime = new Date().getTime();
    let timeout = 5000;
    if (expiryTime > currentTime) {
      timeout = expiryTime - currentTime;
    }
    setTimeout(() => {
      let message = __('Your session is going to expire in 5 minutes. Please save your work');
      const accessToken = TokenManager.getItem(TokenManager.accessTokenKey);
      let oktaAuth = oktaAuthObj;
      try {
        if (accessToken) {
          if (!(oktaAuth && oktaAuth.tokenManager)) {
            oktaAuth = TokenManager.getAuthClient();
            const token = JSON.parse(localStorage.getItem('okta-token-storage'));
            const {
              accessToken: oktaAccessToken = {}
            } = token;
            oktaAuth.tokenManager.add('accessToken', oktaAccessToken);
          }
          message = __('Your session is going to expire in 5 minutes. Please click confirm to extend the session');
          const buttonOptions = {
            text: __('Confirm'),
            func: function func() {
              oktaAuth.tokenManager.renew('accessToken').then(res => {
                const _JwtDecode = JwtDecode(res.accessToken);
                const {
                  exp
                } = _JwtDecode;
                const time = parseInt(''.concat(exp, '000'), 10);
                TokenManager.setItem(TokenManager.tokenExpiryDate, new Date(time).toUTCString());
                TokenManager.setItem(TokenManager.accessTokenKey, res.accessToken);
                onSessionActive(oktaAuth);
              }).catch(() => {
                message = __('Unable to extend Your session. Your session will expire in few minutes. Please save your work');
                notificationHelper('warning', __('Session Expiry'), message, 290, () => {});
              });
            }
          };
          if (isElectron()) {
            buttonOptions.func();
          } else {
            notificationHelper('warning', __('Session Expiry'), message, 290, () => {}, buttonOptions);
          }
        } else {
          notificationHelper('warning', __('Session Expiry'), message, 290, () => {});
        }
      } catch {
        notificationHelper('warning', __('Session Expiry'), message, 290, () => {});
      }
    }, timeout);
  }
};
const stopSessionHandler = () => {
  idleTimer.pause();
};
const onSessionActiveAfterIdle = () => {
  if (window.location.pathname === getLoginPageUrl()) {
    idleTimer.pause();
    return;
  }
  const utcString = TokenManager.getItem(TokenManager.tokenExpiryDate);
  if (utcString && utcString !== 'null') {
    const expireDate = new Date(utcString);
    const remainingHours = (expireDate - new Date()) / (1000 * 60 * 60);
    if (remainingHours < 1) {
      TokenManager.clearAllCookies();
      TokenManager.clearTokenDetails();
    }
  } else if (!TokenManager.getItem(TokenManager.accessTokenKey)) {
    TokenManager.clearAllCookies();
    TokenManager.clearTokenDetails();
  }
};
export { initSessionHandler, stopSessionHandler };